function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11075",
    d: "M19 8.333V7h-8.667v1.333h3.427l-2.913 9.333H7V19h8.667v-1.333H12.24l2.913-9.333z",
    transform: "translate(-7 -7)",
    style: {
      fill: "#203662"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicBlue);
export default __webpack_public_path__ + "static/media/ItalicBlue.85c705b9a96155d32ddbc410558d3fed.svg";
export { ForwardRef as ReactComponent };